
import { defineComponent, PropType } from 'vue';
import useStatus from './useStatus';
import { StatusItem } from '@/types';
import emojiToISO from '@/assets/emojiToISO';

export default defineComponent({
  name: 'CardItem',
  props: {
    server: {
      type: Object as PropType<StatusItem>,
      default: () => ({})
    }
  },
  setup(props) {
    const { getStatus, getRAMStatus, tableRowByteConvert } = useStatus(props);
    // emoji 转 ISO code
    function getRegionISO(regionEmoji: string): string {
      return emojiToISO[regionEmoji] || 'UN'; // 未知时用 UN
    }
    return {
      getStatus,
      getRAMStatus,
      tableRowByteConvert,
      getRegionISO
    };
  }
});
